import { MenuItems, MenuLeft, MenuRight, MenuTop } from "./style";
import { DrawerMenu, DrawerProfile } from "../Drawer";
import { Box, Button, Input } from "@grupoboticario/flora-react";
import {
  HubIcon,
  DocumentBoxIcon,
  MagnifyingGlassIcon,
  ChevronDownIcon,
} from "@grupoboticario/flora-react-icons";
import { DrawerMenuProps } from "../Drawer/DrawerMenu"; 
import { Logo } from "../Logo";

export function Menu(props: DrawerMenuProps) {
  return (
    <>
      <MenuTop>
        <MenuLeft>
          <DrawerMenu items={props.items} />
          <Logo />
          {/* <MenuItems>
            <Box
              css={{
                display: "flex",
                padding: "$8",
                minWidth: "405px",
                maxWidth: "650px",
                flexDirection: "column",
                justifyContent: "center",
                height: "85px",
              }}
            >
              <Input
                id="search"
                invalidText="Error message"
                labelText="Busque por nome, número ou tipo de arquivo"
                optionalText=""
                css={{
                  color: "#FFFFFF !important",
                  background: "#3e4e85",
                  "+ label": { color: "#FFFFFF" },
                }}
                validText="Success message"
                rightIcon={<MagnifyingGlassIcon />}
              />
            </Box>
          </MenuItems> */}
        </MenuLeft>
        <MenuRight>
          {/* <MenuItems>
            <Button
              leftIcon={<DocumentBoxIcon />}
              style={{ background: "transparent" }}
            >
              Comunicados
            </Button>
          </MenuItems>

          <MenuItems>
            <Button
              leftIcon={<HubIcon />}
              style={{ background: "transparent" }}
            >
              Materiais
            </Button>
          </MenuItems>

          <MenuItems>
            <Button
              rightIcon={<ChevronDownIcon />}
              style={{ background: "transparent" }}
            >
              Ajuda
            </Button>
          </MenuItems> */}

          <DrawerProfile />
        </MenuRight>
      </MenuTop>
    </>
  );
}
